import { Bullet } from '@zuto/atoms'
import Box from '@zuto/core/src/box'
import { GridItem } from '@zuto/core/src/grid'
import { Approved, SmallTime } from '@zuto/icons'
import CheckIcon from '@mui/icons-material/Check'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { scrollToTheTop } from '../../Questions/utils'
import { muiColors, muiTypography } from '@zuto/theme/src/mui/DefaultTheme'
import { List, ListItem, styled as MuiStyled } from '@mui/material'
import { v4 as uuidv4 } from 'uuid'
import withFade from '../../HOC/withFade'

const Capsule = styled(Box)`
  border-radius: 60px;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  display: flex;
  align-items: center;
`

const CheckedListWrapper = MuiStyled('div')(({ theme }) => ({
  ul: {
    margin: 0,
    padding: 0
  },
  li: {
    ...muiTypography.body.text.normal,
    padding: 0,
    marginBottom: theme.spacing(3),
    ':last-child': {
      marginBottom: theme.spacing(4)
    }
  }
}))

export type IntroProps = {
  digiLandingPageV1?: boolean
  isInMsmExperiment?: boolean
}

const DefaultIntroduction = ({ digiLandingPageV1 = false, isInMsmExperiment = false }: IntroProps): JSX.Element => {
  useEffect(scrollToTheTop, [])

  const renderControl = () => (
    <GridItem gridColumn={['auto / span 12', '3 / span 8']}>
      <Box as="h1" mt={isInMsmExperiment ? 4 : 6} mb={4} textStyle="display.large.medium">Your finance quote</Box>
      <Bullet icon={<Approved />} mb={4}>{isInMsmExperiment ? <Box as="span" textStyle="body.smallPrint.medium">Quick & simple form</Box> : 'Quotes valid for 30 days'}</Bullet>
      <Bullet icon={<Approved />} mb={5}>
        <Box as="span" textStyle="body.smallPrint.medium">No impact on your credit score</Box>
        &nbsp;- {isInMsmExperiment ? "see your decision in 60 seconds" : "see if you'll be accepted before you choose to proceed"}
      </Bullet>
      <Capsule mb={3} backgroundColor="neutrals.1" pl={5} pr={4} py={2} textStyle="body.smallPrint.regular">
        <Box as="p" my={0} ml={0} mr={4}>Questions take less than 2 mins</Box>
        <SmallTime />
      </Capsule>
    </GridItem>
  )

  const list = [
    'Get a quote with no impact on your credit score',
    '£0 deposit options available',
    'Rated excellent on Trustpilot with over 17,000 reviews'
  ]

  const renderDigiLandingPageV1 = () => {
    return (
      <GridItem gridColumn={['auto / span 12', '3 / span 8']}>
        <Box as="h1" mt={6} mb={4} textStyle="display.large.medium">Your finance quote</Box>
        <CheckedListWrapper data-testid="checked-list">
          <List>
            {list.map((listItem: string) => <ListItem key={uuidv4()}>
              <CheckIcon data-testid="checked-icon" sx={{ color: muiColors.primary.darkGreen, paddingRight: 3, paddingLeft: 0 }} fontSize="medium" />
              {listItem}
            </ListItem>)}
          </List>
        </CheckedListWrapper>
        <Capsule mb={2} backgroundColor="neutrals.1" pl={5} pr={4} py={2} textStyle="body.smallPrint.regular">
          <Box as="p" my={0} ml={0} mr={4}>Questions take less than 2 mins</Box>
          <SmallTime />
        </Capsule>
      </GridItem>
    )
  }

  return digiLandingPageV1 ? renderDigiLandingPageV1() : renderControl()
}

export default withFade(DefaultIntroduction)
